export default "__VITE_ASSET__d3489852__"